import React from 'react';

import Chat from './tabs/Chat';
import Overview from './tabs/Overview';
import Risk from './tabs/Risk';

export interface CreditLineOperationDetailTabConfig {
  value: string;
  label: string;
  Component: React.ComponentType<{ requestId: string }>;
}

export const OPERATION_DETAIL_TABS: CreditLineOperationDetailTabConfig[] = [
  { value: 'overview', label: 'Detalle', Component: Overview },
  { value: 'risk', label: 'Riesgo', Component: Risk },
  { value: 'chat', label: 'Chat', Component: Chat },
];

export const OPERATION_DETAIL_TAB_ITEMS = OPERATION_DETAIL_TABS.map(
  ({ value, label }) => ({ value, label }),
);

export const OPERATION_DETAIL_DEFAULT_TAB = OPERATION_DETAIL_TABS[0].value;

export const getOperationDetailTabComponent = (
  value: string,
): CreditLineOperationDetailTabConfig['Component'] | undefined =>
  OPERATION_DETAIL_TABS.find((tab) => tab.value === value)?.Component;
